import { Device } from './entity/device';

export class UserRouteLogDevice {
  routeId: String;
  displayName: String;
  devices: Device[];
  isSelected: boolean;
}
